<template lang="pug">
#app
  v-dialog(v-model="dialog.cancelar", max-width="600", persistent)
    v-card(v-if="pedido && pedido.id")
      v-card-title.title Cancelar Pedido
      v-card-text
        v-layout(row, wrap)
          v-flex.xs12
            v-radio-group(v-model="pedido.tipo_cancelamento")
              v-radio(v-for="(tipo, index) in tipos_cancelamento", :key="index", :label="tipo.tipo", :value="tipo.id")
        v-layout(row, wrap, v-if="pedido.tipo_cancelamento == 0")
          v-flex.xs12
            v-textarea(label="Motivo do cancelamento", color="gray", v-model="pedido.motivo", required, rows="3")
      v-card-actions
        v-spacer
        v-btn(flat, type="button", :disabled="loading", @click="dialog.cancelar = false; pedido = null;") Fechar
        v-btn(color="accent", type="button", :loading="loading", @click="setStatusPedido(pedido, 3)").white--text Salvar

  v-dialog(v-model="dialog.fecharLoja", max-width="480", persistent)
    v-card
      v-card-title.title Deseja fechar a loja?
      v-card-text
        p.subheading.mb-0 Você cancelou um pedido informando "{{ motivoFecharLoja }}".
        p.subheading Enquanto a loja continuar aberta, você seguirá recebendo novos pedidos. Deseja fechá-la agora?
      v-card-actions
        v-spacer
        v-btn(flat, type="button", @click="dialog.fecharLoja = false") Manter aberta
        v-btn(color="accent", type="button", @click="confirmarFecharLoja()").white--text Fechar loja

  v-dialog(v-model="dialog.infoUsuario", max-width="600", v-if="infoUsuario && dialog.infoUsuario")
    v-card.cardPadrao.Poppins
      v-card-title.title.headerDialog
        v-layout(row, wrap)
          v-flex.xs6.Poppins Perfil do Cliente
          v-flex.xs6.text-xs-right.d-flex.align-center
            small.Poppins # {{infoUsuario.usuario.id}}
      v-card-text.pb-0
        v-layout(row, wrap, v-if="infoUsuario.usuario")
          v-flex.xs12
            v-layout(row, wrap, align-center)
              v-flex.md2.text-xs-center
                v-avatar(v-if="infoUsuario.usuario.imagem && infoUsuario.usuario.imagem != ''")
                  img(:src="`${urlImagem}/usuario/${infoUsuario.usuario.imagem}`", style="width: 100%; margin-right: 10px")
                v-avatar(v-else)
                  img(:src="`https://graph.facebook.com/v2.10/${infoUsuario.usuario.facebook_id}/picture?type=large`", style="width: 100%; margin-right: 10px", v-if="infoUsuario.usuario.facebook_id && infoUsuario.usuario.facebook_id != ''")
                  img(src="@/assets/images/user.png", style="width: 100%; margin-right: 10px", v-else)
              v-flex.md9
                label.subheading {{ infoUsuario.usuario.nome }}
                .caption {{ infoUsuario | telefone }}
        v-layout(row, wrap).mt-4
          v-flex.md12.xs12.pa-1
            .subheading Pedidos na Plataforma
          v-flex.md6.xs12.pa-1
            v-layout.areaSeparacao.bg-verde(row, wrap)
              v-flex.md3.xs4.areaInfo
                strong.headline.font-weight-medium {{ infoUsuario.total_pedidos }}
              v-flex.md9.xs8
                span.caption {{ infoUsuario.total_pedidos == 1 ? ' pedido' : ' pedidos ' }} na plataforma
          v-flex.md6.xs12.pa-1
            v-layout.areaSeparacao.bg-verde(row, wrap)
              v-flex.md3.xs4.areaInfo
                strong.headline.font-weight-medium {{ infoUsuario.percentual_aceitos  + '% '}}
              v-flex.md9.xs8
                span.caption de pedidos aceitos na plataforma
        v-layout(row, wrap)
          v-flex.md6.xs12.pa-1
            v-layout.areaSeparacao.bg-verde(row, wrap)
              v-flex.md3.xs4.areaInfo
                strong.headline.font-weight-medium {{ infoUsuario.pedidos_recusados}}
              v-flex.md9.xs8
                span.caption {{infoUsuario.pedidos_recusados == 1 ? ' pedido cancelado' : ' pedidos cancelados'}}
          v-flex.md6.xs12.pa-1
            v-layout.areaSeparacao.bg-verde(row, wrap)
              v-flex.md3.xs4.areaInfo
                strong.headline.font-weight-medium {{ infoUsuario.pedidos_expirados + ' '}}
              v-flex.md9.xs8
                span.caption pedidos cancelados pelo tempo de espera
        v-layout(row, wrap).mt-3
          v-flex.md12.xs12.pa-1
            .subheading Pedidos em {{ infoUsuario.estabelecimento }}
          v-layout(row, wrap)
            v-flex.md6.xs12.pa-1
              v-layout.areaSeparacao(row, wrap)
                v-flex.md3.xs4.areaInfo
                  strong.headline.font-weight-medium {{ infoUsuario.pedidos_estabelecimento }}
                v-flex.md9.xs8
                  span.caption {{ infoUsuario.pedidos_estabelecimento == 1 ? ' pedido feito ' : ' pedidos feitos ' }} em {{ infoUsuario.estabelecimento }}
            v-flex.md6.xs12.pa-1
              v-layout.areaSeparacao(row, wrap)
                v-flex.md3.xs4.areaInfo
                  strong.headline.font-weight-medium {{ infoUsuario.percentual_aceitos_estabelecimento }}%
                v-flex.md9.xs8
                  span.caption pedidos aceitos em {{ infoUsuario.estabelecimento }}
      v-card-actions
        v-spacer
        v-btn(flat, type="button", @click="dialog.infoUsuario = false; infoUsuario = null;") Fechar

  div(style="height: calc(100vh - 112px); overflow: hidden; display: flex; flex-direction: column;")
    v-layout(row, wrap, style="flex: 0 0 auto;")
      v-flex.xs12
        StatusDelivery(v-if="estabelecimentoSelecionado")
    v-layout(row, wrap, style="flex: 0 0 auto;")
      v-flex.xs12
        AnnouncementBanners(v-if="estabelecimentoSelecionado", :estabelecimentoId="estabelecimentoSelecionado.id")
    v-container(grid-list-md, fluid, style="overflow: hidden; flex: 1; min-height: 0; display: flex; flex-direction: column;")
      v-layout(row, wrap, style="overflow: hidden; flex: 1; min-height: 0;")
        v-flex.md6(v-if="!$root.pedido_mobile", style="max-height: 100%;")
          v-layout(row, wrap, style="max-height: min-content; overflow: hidden;")
            v-flex.xs12.md12
              v-layout(row, wrap).grey.lighten-2.pa-2
                v-flex.xs12
                  .title.font-weight-bold.gray--text {{ $root.pedidosAguardando ? $root.pedidosAguardando == 1 ? `${$root.pedidosAguardando} pedido` : `${$root.pedidosAguardando} pedidos` : 'Nenhum pedido' }} aguardando confirmação
                    v-tooltip(top)
                      v-btn(icon, slot="activator", @click="refreshPedidos").pa-0.ma-0.ml-3
                        v-icon refresh
                      span Atualizar Lista de Pedidos
          v-container(style="overflow-x: hidden; overflow-y: scroll; max-height: calc(100% - 60px);")
            v-layout(row, wrap, v-if="$root.pedidos.length", style="max-height: 100%;")
              v-card(flat, width="100%", v-for="(pedido, indexPedido) in pedidosRender", :key="indexPedido", @click="selectPedido(pedido)", style="cursor: pointer", :dark="checkSelected(pedido)")
                v-card-text(:style="'opacity:' + (pedido.status == 3 || pedido.concluido == 1 ? '0.5' : '1')")
                  v-layout(row, wrap, align-center, v-if="$vuetify.breakpoint.mdAndUp")
                    v-flex.md2(v-if="pedido.status == 0").text-xs-center
                      v-card(flat, :color="checkSelected(pedido) ? 'rgb(52,56,64)' : ''", style="border-radius: 5px; border: 1px solid #999;").pa-1
                        .caption EXPIRA EM
                        .title.font-weight-bold {{ pedido.timeLeft }}
                        .caption MINUTOS
                    v-flex.md2(v-else).text-xs-center
                      div(v-if="pedido.status == 3")
                        v-avatar(size="68px")
                          img(src="@/assets/images/user.png", style="width: 100%; margin-right: 10px")
                      div(v-else)
                        v-avatar(size="68px", v-if="pedido.usuario.imagem && pedido.usuario.imagem != ''")
                          img(:src="`${urlImagem}/usuario/${pedido.usuario.imagem}`", style="width: 100%; margin-right: 10px")
                        v-avatar(size="68px", v-else)
                          img(:src="`https://graph.facebook.com/v2.10/${pedido.usuario.facebook_id}/picture?type=large`", style="width: 100%; margin-right: 10px", v-if="pedido.usuario.facebook_id && pedido.usuario.facebook_id != ''")
                          img(src="@/assets/images/user.png", style="width: 100%; margin-right: 10px", v-else)
                    v-flex.md5
                      v-layout(row, wrap)
                        v-flex.md12
                          .body-2.font-weight-bold(v-if="$root.showIdentify(pedido)") {{ pedido.usuario.nome }}
                          .body-1 {{ pedido.estabelecimento.nome }}
                          .caption {{ pedido.estabelecimento.localidades[0].nome + ' - ' + pedido.estabelecimento.localidades[0].estado }}
                      v-layout(row, wrap)
                        v-flex.md12
                          BadgeOrigem(:cardapio_digital="pedido.cardapio_digital ? true : false", :label="true")
                    v-flex.md4
                      v-layout(row, wrap)
                        v-flex.md8
                          v-card(flat, :color="checkSelected(pedido) ? 'rgb(52,56,64)' : ''", style="border-radius: 5px; border: 1px solid #999;").pa-1.text-xs-center
                            .body-1.text-xs-center.font-weight-bold PEDIDO: {{ pedido.id }}
                            .body-1 {{pedido.total | currency}}
                        v-flex.md4
                          v-card(flat, :color="checkSelected(pedido) ? 'rgb(52,56,64)' : ''", style="border-radius: 5px; border: 1px solid #999;").pa-1.text-xs-center
                            .body-1.font-weight-bold HORA
                            .body-1 {{ $dayjs(pedido.data).format('HH:mm') }}
                      v-layout(row, wrap)
                        v-flex.md8
                          v-chip.ma-0.mt-1(label, small, :class="['lb-success', 'lb-warning', 'lb-primary', 'lb-danger', 'lb-success', 'gray'][pedido.concluido && pedido.status !== 3 ? 5 : pedido.status ]").white--text.font-weight-bold {{ pedido.concluido && pedido.status !== 3 ? 4 : pedido.status | statusPedido }}

                    v-flex.md1.text-xs-right
                      v-icon(:color="checkSelected(pedido) ? 'white' : 'gray'") arrow_forward_ios

                  v-layout(row, wrap, align-center, v-else)
                    v-flex.xs3
                      .text-xs-center(v-if="pedido.status == 0")
                        v-card(flat, :color="checkSelected(pedido) ? 'rgb(52,56,64)' : ''", style="border-radius: 5px; border: 1px solid #999;").pa-1
                          .caption EXPIRA EM
                          .title.font-weight-bold {{ pedido.timeLeft }}
                          .caption MINUTOS
                      .text-xs-center(v-else)
                        v-avatar(size="68px")
                          img(src="@/assets/images/user.png", style="width: 100%; margin-right: 10px")
                        //- div(v-if="pedido.status == 3")
                        //-   v-avatar(size="68px")
                        //-     img(src="@/assets/images/user.png", style="width: 100%; margin-right: 10px")
                        //- div(v-else)
                        //-   v-avatar(size="68px", v-if="pedido.usuario.imagem && pedido.usuario.imagem != ''")
                        //-     img(:src="`${urlImagem}/usuario/${pedido.usuario.imagem}`", style="width: 100%; margin-right: 10px")
                        //-   v-avatar(size="68px", v-else)
                        //-     img(:src="`https://graph.facebook.com/v2.10/${pedido.usuario.facebook_id}/picture?type=large`", style="width: 100%; margin-right: 10px", v-if="pedido.usuario.facebook_id && pedido.usuario.facebook_id != ''")
                        //-     img(src="@/assets/images/user.png", style="width: 100%; margin-right: 10px", v-else)
                    v-flex.xs9
                      .body-2.font-weight-bold(v-if="$root.showIdentify(pedido)") {{ pedido.usuario.nome }}
                      .body-1 {{ pedido.estabelecimento.nome }}
                      .caption {{ pedido.estabelecimento.localidades[0].nome + ' - ' + pedido.estabelecimento.localidades[0].estado }}
                      v-chip.ma-0.mt-1(label, small, :class="['lb-success', 'lb-warning', 'lb-primary', 'lb-danger', 'gray'][pedido.concluido && pedido.status !== 3 ? 4 : pedido.status]").white--text.font-weight-bold {{ pedido.concluido && pedido.status !== 3 ? 4 : pedido.status | statusPedido }}
                    v-flex.md8.mt-1
                      v-card(flat, :color="checkSelected(pedido) ? 'rgb(52,56,64)' : ''", style="border-radius: 5px; border: 1px solid #999;").text-xs-center
                        .body-1.text-xs-center.font-weight-bold PEDIDO: {{ pedido.id }}
                        .body-1 {{pedido.total | currency}}
                    v-flex.md4.mt-1
                      v-card(flat, :color="checkSelected(pedido) ? 'rgb(52,56,64)' : ''", style="border-radius: 5px; border: 1px solid #999;").text-xs-center
                        .body-1.font-weight-bold HORA
                        .body-1 {{ $dayjs(pedido.data).format('HH:mm') }}
                v-divider

            v-layout(row, wrap, v-if="$root.pedidos.length > renderCount").mt-2
              v-flex.md12.text-xs-center
                v-btn(@click="renderCount += 10;", flat) CARREGAR MAIS PEDIDOS...

        v-flex.md6(v-if="$vuetify.breakpoint.mdAndUp || ($root.pedido_mobile && $vuetify.breakpoint.smAndDown)")
          v-layout(row, wrap, v-if="$root.pedidoSelecionado && $root.pedidoSelecionado.id")
            v-flex.md12
              v-layout(row, wrap)
                v-flex.md12.pa-0
                  v-card(dark, flat)
                    v-card-text
                      v-layout(row, wrap)
                        v-flex.md4.xs4
                          .rotulo-pedido Pedido
                          .numero-pedido {{ '#' + $root.pedidoSelecionado.id }}
                        v-flex.md4.xs8
                          .rotulo-pedido Cliente
                          template(v-if="$root.showIdentify($root.pedidoSelecionado)")
                            .cliente-pedido
                              .subheading.font-weight-medium {{ $root.pedidoSelecionado.usuario.nome }}
                            v-btn.ma-0.mt-2.btn-pedido.btn-contorno-neutro(outline, @click="openDialogPerfil($root.pedidoSelecionado)", v-if="$root.pedidoSelecionado.cardapio_digital == 0") Ver perfil
                          .caption.font-weight-regular.mr-5(v-else) As informações da pessoa só estarão disponíveis após aceitar o pedido.
                        v-flex.md4.xs12
                          .rotulo-pedido Status
                            span.ml-1(v-if="confirmadoAutomaticamente") (confirmado automaticamente)
                          v-chip.ma-0.status-pedido(small, :color="statusPedidoSelecionado.cor", :text-color="statusPedidoSelecionado.corTexto")
                            span.status-dot
                            | {{ statusPedidoSelecionado.indice | statusPedido }}
                          br
                          v-chip.ma-0.mt-1(v-if="$root.pedidoSelecionado.status_integracao", label, small, :class="['lb-success', 'lb-danger'][$root.pedidoSelecionado.status_integracao == 1 ? 0 : 1]").white--text.font-weight-bold {{ $root.pedidoSelecionado.status_integracao == 1 ? 'INTEGRADO' : 'ERRO NA INTEGRAÇÃO' }}

                      v-divider.mt-3.mb-1(v-if="($vuetify.breakpoint.mdAndUp && $root.pedidoSelecionado.status !== 3) || ($vuetify.breakpoint.smAndDown && $root.pedidoSelecionado.status < 2)")
                      v-layout.acoes-pedido(row, wrap, align-center)
                        v-btn(depressed, @click="setStatusPedido($root.pedidoSelecionado, 1)", color="lb-primary", v-if="$root.pedidoSelecionado.status == 0") Aceitar
                        v-btn(depressed, @click="setStatusPedido($root.pedidoSelecionado, 2)", color="lb-primary", v-if="$root.pedidoSelecionado.status == 1") {{ $root.pedidoSelecionado.endereco.id == -1 ? 'Disponível para retirada' : 'Saiu para Entrega' }}
                        v-btn(depressed, @click="setConcluidoPedido($root.pedidoSelecionado)", color="lb-primary", v-if="$root.pedidoSelecionado.status == 2 && $root.pedidoSelecionado.concluido == 0") Concluir
                        BotaoAvisarClienteWhatsApp(:pedido="$root.pedidoSelecionado")
                        v-btn.btn-contorno-neutro(outline, @click="printPedido($root.pedidoSelecionado)", v-if="$root.pedidoSelecionado.status == 1 || $root.pedidoSelecionado.status == 2").hidden-sm-and-down Imprimir
                        v-spacer
                        v-btn.btn-contorno-perigo(outline, @click="openDialogCancelar($root.pedidoSelecionado)", color="red lighten-2", v-if="$root.pedidoSelecionado.status == 0 || ($root.pedidoSelecionado.cardapio_digital == 1 && $root.pedidoSelecionado.status != 3)") {{ $root.pedidoSelecionado.status == 1 || $root.pedidoSelecionado.status == 2 ? 'Cancelar pedido' : 'Recusar pedido'}}

                      v-divider.my-2(v-if="$root.pedidoSelecionado.status == 3")
                      v-layout(row, wrap, v-if="$root.pedidoSelecionado.status == 3")
                        v-flex.md12
                          .subheading.font-weight-bold Motivo do cancelamento:
                            .font-weight-regular {{ $root.pedidoSelecionado.motivo }}

              v-container(style="overflow-x: hidden;", :style="{'height': $root.pedido_mobile ? 'calc(100vh - 330px)' : 'calc(100vh - 280px)'}").ticket#scroll-target.scroll-y
                ticketPadrao(v-if="$root.layoutImpressaoNormalSelecionado", :pedido="$root.pedidoSelecionado")
                ticketNovo(v-if="!$root.layoutImpressaoNormalSelecionado", :pedido="$root.pedidoSelecionado")
</template>

<script>
import _ from 'lodash';
import ticketPadrao from "@/components/TicketPadrao";
import ticketNovo from "@/components/TicketNovo";
import StatusDelivery from "@/components/StatusDelivery";
import BadgeOrigem from "@/components/BadgeOrigem";
import AnnouncementBanners from "@/components/AnnouncementBanners";
import BotaoAvisarClienteWhatsApp from "@/components/BotaoAvisarClienteWhatsApp";

export default {
  components: {
    ticketNovo,
    ticketPadrao,
    StatusDelivery,
    BadgeOrigem,
    AnnouncementBanners,
    BotaoAvisarClienteWhatsApp
  },
  data() {
    return {
      renderCount: 10,
      infoUsuario: null,
      dialog: {
        infoUsuario: false,
        cancelar: false,
        fecharLoja: false,
      },
      pedido: null,
      loading: false,
      estabelecimentoFecharLoja: null,
      motivoFecharLoja: '',
      // tipos de cancelamento que indicam que a loja não consegue atender no momento
      tipos_cancelamento_sugere_fechamento: [5, 6],
      tipos_cancelamento: [
        { id: 2, tipo: 'Pedido duplicado' },
        { id: 4, tipo: 'Pedido não entregue' },
        { id: 5, tipo: 'Desculpe, não estamos funcionando hoje' },
        { id: 6, tipo: 'Infelizmente estamos sem entregador' },
        { id: 8, tipo: 'Cliente recusou o pedido' },
        { id: 0, tipo: 'Mensagem personalizada' },
      ],
    }
  },
  computed: {
    pedidosRender () {
      return this.$root.pedidos.slice(0, this.$root.pedidosAguardando > this.renderCount ? this.$root.pedidosAguardando : this.renderCount);
    },
    urlImagem(){
      return process.env.VUE_APP_IMAGE_URL;
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado
    },
    confirmadoAutomaticamente () {
      if (!this.$root.pedidoSelecionado || !this.$root.pedidoSelecionado.status_pedido || !this.$root.pedidoSelecionado.status_pedido.length || this.$root.pedidoSelecionado.status == 3) {
        return false
      }
      return this.$root.pedidoSelecionado.status_pedido.some(status => status.status == 1 && status.tipo == 1 && !status.usuario_id && !status.admin_estabelecimento_id);
    },
    statusPedidoSelecionado () {
      const pedido = this.$root.pedidoSelecionado;
      if (!pedido) return {};
      const concluido = pedido.concluido && pedido.status !== 3;
      return {
        indice: concluido ? 4 : pedido.status,
        cor: concluido ? 'gray' : ['lb-success', 'lb-warning', 'lb-primary', 'lb-danger'][pedido.status],
        corTexto: !concluido && pedido.status == 1 ? 'grey darken-4' : 'white',
      };
    },
  },
  mounted(){
    this.refreshPedidos ()
  },
  created () {

  },
  methods: {
    async setStatusPedido (pedido, status) {
      const vm = this;
      try {
        const objPedido = _.cloneDeep(pedido);
        if (status == 3) {
          if (objPedido.tipo_cancelamento == 0 && (!objPedido.motivo || objPedido.motivo.trim() == ''))
            return window.getApp.$emit("APP_ALERT", { color: "red", text: 'É necessário informar o motivo do cancelamento!' });
          objPedido.motivo = objPedido.tipo_cancelamento == 0 ? objPedido.motivo : _.find(vm.tipos_cancelamento, { id: objPedido.tipo_cancelamento }).tipo;
        }
        objPedido.status = status;
        vm.loading = true;
        await vm.$axios.put('/pedido', objPedido);
        vm.dialog.cancelar = false;
        if(status == 1 && vm.$root.print.id == 2) {
					setTimeout(() => {
						vm.printPedido(objPedido);
					}, 500);
				};
        vm.pedido = null;
        vm.loading = false;
        window.getApp.$emit("APP_ALERT", { color: "success", text: 'Status alterado com sucesso!' });
        if (status == 3) {
          vm.verificarSugestaoFecharLoja(objPedido);
        }
      } catch (error) {
        vm.loading = false;
        window.getApp.$emit("APP_ALERT", { color: "red", text: 'Ocorreu um erro ao atualizar o pedido!' });
      }
    },
    async setConcluidoPedido(pedido){
      const vm = this;
      try {
        const objPedido = _.cloneDeep(pedido);
        objPedido.concluido = 1;
        vm.loading = true;
        await vm.$axios.put('/pedido/update', objPedido);
        vm.$root.pedidoSelecionado.concluido = 1;
        vm.pedido = null;
        vm.loading = false;
        window.getApp.$emit('APP_UPDATE_PEDIDOS', objPedido);
        window.getApp.$emit("APP_ALERT", { color: "success", text: 'Status alterado com sucesso!' });
      } catch (error) {
        window.getApp.$emit("APP_ALERT", { color: "red", text: 'Ocorreu um erro ao atualizar o pedido!' });
      }
    },
    // Após um cancelamento manual por indisponibilidade ("sem entregador" ou
    // "não estamos funcionando hoje"), sugere fechar a loja para o parceiro não
    // continuar recebendo pedidos que não consegue atender.
    verificarSugestaoFecharLoja (pedido) {
      const vm = this;
      if (!_.includes(vm.tipos_cancelamento_sugere_fechamento, Number(pedido.tipo_cancelamento))) return;

      const estabelecimento = vm.getEstabelecimentoDoPedido(pedido);
      if (!vm.isEstabelecimentoAberto(estabelecimento)) return;

      const tipo = _.find(vm.tipos_cancelamento, { id: Number(pedido.tipo_cancelamento) });
      vm.motivoFecharLoja = tipo ? tipo.tipo : pedido.motivo;
      vm.estabelecimentoFecharLoja = estabelecimento;
      vm.dialog.fecharLoja = true;
    },
    getEstabelecimentoDoPedido (pedido) {
      const vm = this;
      return _.find(vm.$root.estabelecimentos, o => o.id == pedido.estabelecimento_id) || vm.estabelecimentoSelecionado;
    },
    isEstabelecimentoAberto (estabelecimento) {
      const delivery = estabelecimento && estabelecimento.delivery ? estabelecimento.delivery[0] : null;
      return delivery && delivery.aberto == 1 ? true : false;
    },
    confirmarFecharLoja () {
      const vm = this;
      vm.dialog.fecharLoja = false;
      window.getApp.$emit('OPEN_DIALOG_CLOSE_TIMER', vm.estabelecimentoFecharLoja);
      vm.estabelecimentoFecharLoja = null;
    },
    openDialogCancelar (pedido) {
      const vm = this;
      vm.pedido = _.cloneDeep(pedido);
      vm.pedido.tipo_cancelamento = vm.pedido.tipo_cancelamento || 0;
      vm.dialog.cancelar = true;
    },
    createInfoUsuario(pedido) {
      const pedidos = pedido.usuario.pedidos;

      const total_pedidos = pedidos.length;
      const pedidos_estabelecimento = _.filter(pedidos, { estabelecimento_id: pedido.estabelecimento_id });
      const aceitos_estabelecimento = _.filter(pedidos_estabelecimento, p => p.status === 1 || p.status === 2).length;
      const pedidos_aceitos = _.filter(pedidos, p => p.status === 1 || p.status === 2).length;
      const pedidos_recusados = _.filter(pedidos, { status: 3 }).length;
      const percentual_aceitos = Math.round(pedidos_aceitos / total_pedidos * 100) || 0;
      const pedidos_expirados = _.filter(pedidos, { tipo_cancelamento: 1, status: 3 }).length;
      const percentual_aceitos_estabelecimento = Math.round(aceitos_estabelecimento / pedidos_estabelecimento.length * 100) || 0;

      return {
        usuario: pedido.status === 1 || pedido.status === 2 ? pedido.usuario : null,
        estabelecimento: pedido.estabelecimento.nome,
        pedido: pedido,
        total_pedidos,
        pedidos_recusados,
        pedidos_estabelecimento: pedidos_estabelecimento.length,
        percentual_aceitos,
        pedidos_expirados,
        percentual_aceitos_estabelecimento,
      };
    },
    async openDialogPerfil (pedido) {
      const vm = this;
      try {
        const { data: pedidos } = await vm.$axios.get('/pedido', {
          params: {
            valido: true,
            orderDesc: 'data',
            usuario_id: pedido.usuario_id,
            fields: 'none'
          }
        });
        pedido.usuario.pedidos = pedidos;
        vm.infoUsuario = vm.createInfoUsuario(pedido);
        vm.dialog.infoUsuario = true;
      } catch (error) {
        window.getApp.$emit("APP_ALERT", { color: "red", text: 'Ocorreu um erro ao abrir o perfil do usuário!' });
      }
    },
    checkSelected (pedido) {
      return this.$root.pedidoSelecionado && this.$root.pedidoSelecionado.id == pedido.id ? true : false;
    },
    selectPedido (pedido) {
      const vm = this;
      if (vm.$vuetify.breakpoint.smAndDown)
        vm.$root.pedido_mobile = _.cloneDeep(pedido);
      vm.$root.pedido = _.cloneDeep(pedido);
    },
    async printPedido (pedido) {
      const vm = this;
      try {
        await vm.$root.printPedido(pedido);
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'orange darken-1', text: error.message });
      }
    },
    refreshPedidos () {
      const vm = this;
      vm.$parent.$parent.getPedidos();
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
}
.cardPadrao{
    box-shadow:none !important;
    border-radius: 10px !important;
}
.Poppins {
  font-family: "Poppins", "Roboto", "Helvetica";
}
.headerDialog{
  border-bottom: 1px solid rgba(0,0,0,0.2)
}
.areaSeparacao{
  padding: 10px 5px!important;
  border-radius: 10px;
  background-color: #f5f5f5;
  min-height: 65px;
  display: flex;
  align-items: center;
}
.areaInfo{
  display: flex;
  justify-content: center;
}
.bg-verde{
  background-color: rgba(29, 154, 90, 0.2);
  border: 1px solid rgba(29, 154, 90, 0.3)
}
.rotulo-pedido {
  font-size: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 4px;
  span {
    text-transform: none;
    letter-spacing: 0;
  }
}
.numero-pedido {
  font-family: "Roboto Mono", Menlo, Consolas, monospace;
  font-size: 22px;
  font-weight: 500;
  line-height: 28px;
}
.cliente-pedido {
  display: flex;
  align-items: center;
}
.status-pedido {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.status-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: currentColor;
  margin-right: 6px;
}
.acoes-pedido .v-btn,
.v-btn.btn-pedido {
  height: 34px;
  padding: 0 16px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 4px;
}
.acoes-pedido .v-btn {
  margin: 12px 10px 0 0;
}
.v-btn.btn-contorno-neutro {
  color: #fff;
  border-color: #737b8c;
}
.acoes-pedido .btn-contorno-perigo {
  margin-right: 0;
  border-color: #c0504d;
}
</style>
